function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.4572 54H52.5428C57.5301 54 60 51.5144 60 46.591V17.409C60 12.4856 57.5301 10 52.5428 10H11.4572C6.49364 10 4 12.4617 4 17.409V46.591C4 51.5383 6.49364 54 11.4572 54ZM21.8117 32.5856C18.5818 32.5856 15.9457 29.9326 15.9457 26.6822C15.9457 23.4557 18.5818 20.7789 21.8117 20.7789C25.0178 20.7789 27.6539 23.4557 27.6539 26.6822C27.6539 29.9326 25.0178 32.5856 21.8117 32.5856ZM11.5047 50.1521C9.20102 50.1521 7.82358 48.7659 7.82358 46.4237V44.9658L15.1145 38.5606C16.1595 37.6285 17.2994 37.1505 18.3444 37.1505C19.5081 37.1505 20.7193 37.6285 21.7642 38.6084L26.3003 42.7192L37.6522 32.5856C38.8159 31.5339 40.1221 31.0559 41.4758 31.0559C42.782 31.0559 44.1357 31.5578 45.2519 32.6095L56.1764 42.7909V46.4715C56.1764 48.7659 54.7752 50.1521 52.5191 50.1521H11.5047Z",
  fill: "#4F4C57"
});

function SvgIconImageInverse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImageInverse);
export default __webpack_public_path__ + "static/media/icon-image-inverse.e9c57db2.svg";
export { ForwardRef as ReactComponent };